<template>
    <div class="files-management">
        <h3>Gerenciamento de arquivos</h3>
        <div class="buttons">
            <button class="button" type="button" @click="callback(selected)" :disabled="!selected">Confirmar</button>
            <button class="button white" type="button" @click="newFile = true">Enviar novo arquivo</button>
        </div>
        <div class="files">
            <div class="file" v-for="(file, i) in files" :key="i" @click="toggleFile(file)" :class="{'selected': selected && file.url == selected.url, 'unselected': selected && file.url != selected.url}">
                <img :src="file.url" :alt="file.name">
                <p><i class="ico-attach_file"></i> <span class="filename">{{ file.name }}</span> <span>- {{ convertFileSize(file.size) }}</span></p>
            </div>
        </div>
        <div class="buttons">
            <button class="button" type="button" @click="callback(selected)" :disabled="!selected">Confirmar</button>
            <button class="button white" type="button" @click="newFile = true">Enviar novo arquivo</button>
        </div>
        <modal :show="newFile" v-model="newFile">
            <h3 slot="header">Enviar novo arquivo</h3>
            <div slot="body" v-if="newFile">
                <uploader :callback="load"></uploader>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from './Modal'
import Uploader from './Uploader.vue'
export default {
    name: "FileManagement",
    components: {
        Modal,
        Uploader
    },
    data(){
        return {
            newFile: false,
            loading: true,
            show: false,
            files: [],
            uploadNew: false,
            selected: false,
        }
    },
    props: {
        callback: {
            type: Function
        }
    },
    mounted(){
        this.load()
    },
    methods: {
        toggleFile(file){
            this.selected = (this.selected == file) ? null : file
        },
        convertFileSize(bytes, decimalPoint = 1) {
            if (bytes == 0) return '0 Bytes';
            var k = 1000,
                dm = decimalPoint || 2,
                sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
                i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        },
        load() {
            this.newFile = false
            this.loading = true
            this.$db.collection("files").get().then((snap) => {
                let files = []
                this.loading = true
                snap.forEach((doc) => {
                    let data = doc.data()
                    data.docId = doc.id
                    files.push(data)
                });

                this.files = files
                this.loading = false
            })
        }
    }
}
</script>
<style scoped lang="scss">
    .files{
        column-count: 5;
        column-gap: 15px;
        padding: 10px 3px;
        .file{
            box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1), inset 0 0 0 2px rgba(0, 0, 0, 0.0);
            padding: 2px;
            column-fill: auto;
            column-rule-style: solid;
            column-fill: auto;
            break-inside: avoid;
            border-radius: 3px;
            overflow: hidden;
            margin-bottom: 10px;
            column-gap: 10px;
            cursor: pointer;
            transition: .3s all;
            &.selected{
                box-shadow: inset 0 0 0 2px #32499b;
            }
            &.unselected{
                filter: blur(3px);
                opacity: .9
            }
            img{
                width: 100%;
            }

            p{
                display: flex;

                font-size: .63em;
                font-weight: bold;
                padding: 5px;
                align-items: center;
                .filename{
                    padding: 0 5px;
                    text-overflow: ellipsis;
                    width: min-content;
                    max-width: 100%;
                    overflow: hidden;
                    /* padding: 10px; */
                    margin: 0;
                }
                span{
                    white-space: nowrap;
                }
            }
        }
    }
</style>